<template>
  <header>
    <!-- HEADER TOP START -->
    <div class="loader-pane" id="loading" v-if="isLoading">
      <div class="loader"></div>
    </div>
    <!-- <div class="header-top">
      <div class="container pb-5 fix-height">
        <div class="row">
          <div class="col-md-3 padding0 mx-auto">
            <div
              class="mx-auto text-center"
              style="
                height: 100px !important;
                background: #1d1f29;
                padding-top: 60px;
                text-align: center;
              "
              v-html="adsenseContent"
            > -->
    <!-- <a href="/">
                <img src="../../../static/images/fintransform-logo.png" alt="logo" />
              </a>-->
    <!-- google -->
    <!-- </div> -->
    <!-- logo -->
    <!-- </div>
        </div> -->
    <!-- <div class="col-md-6 padding0">
          <div class="office-info">
            <div class="col-xs-4 padding-left0">
              <div class="address">
                <i class="icon_pin_alt"></i>
                <h2>35 North Road, NY</h2>
                <span>Find us</span>
              </div>
            </div>
            <div class="col-xs-4 padding-left0">
              <div class="address">
                <i class="icon_phone"></i>
                <h2>484-961-5304</h2>
                <span>Call us</span>
              </div>
            </div>
            <div class="col-xs-4 padding0">
              <div class="address">
                <i class="icon_clock_alt"></i>
                <h2>Mon - Fri: 9am - 5pm</h2>
                <span>Sunday closed</span>
              </div>
            </div>
          </div>

        </div>-->
    <!-- office info -->
    <!-- <div class="col-md-3 padding-right0">
          <div class="get-quote pull-right">
            <a style="width: 100%;padding:5px" @click="login">Go To Financail statements</a>
          </div>
        </div>-->
    <!-- </div>
    </div> -->
    <!-- HEADER TOP END -->
    <!-- # -->
    <!-- MAIN MANU START -->
    <div class="main-menu hidden-xs">
      <div class="container-fluid p-0">
        <nav id="finanz-menu">
          <!-- Collect the nav links, forms, and other content for toggling -->

          <div class="collapse navbar-collapse" id="responsive-icon">
            <a href="/" class="logo-link">
              <img src="../../../static/images/logo-old.png" alt="logo" />
            </a>
            <ul class="nav navbar-nav text-center nav-list">
              <li v-for="menu in menus" :key="menu.name">
                <a :href="menu.link">
                  {{ menu.name }}
                  <i v-if="menu.hasChild" class="fa fa-caret-down"></i>
                </a>
                <ul v-if="menu.hasChild" class="dropdown-menu">
                  <li v-for="child in menu.childs" :key="child.name">
                    <a :href="child.link">{{ child.name }}</a>
                  </li>
                </ul>
              </li>
              <li v-if="!isLoggedIn">
                <a href="/login" data-target="#">SIGN-IN</a>
              </li>
              <li v-if="!isLoggedIn">
                <a href="/register" data-target="#">SIGN-UP</a>
              </li>
              <li v-if="isLoggedIn">
                <a>
                  {{ loggedInUser.name }}
                  <i class="fa fa-caret-down"></i>
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a href="/financial-statements"
                      >Manage Financial Statements</a
                    >
                  </li>
                  <li>
                    <a href="/manageSubscription">Manage Subscription</a>
                  </li>
                  <li>
                    <a href="/payment-information">Payment Information</a>
                  </li>
                  <li>
                    <a href="/customerProfile">Profile</a>
                  </li>
                  <li>
                    <a @click="logout">Logout</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!-- /.navbar-collapse -->
        </nav>
        <!-- /#finanz-menu -->
      </div>
    </div>
    <!-- MAIN MENU END -->
    <div class="menu-bg" v-bind:class="{ fs: isToggle }"></div>
    <div
      class="menu-burger"
      v-bind:class="{ fs: isToggle }"
      @click="menuToggle()"
    >
      {{ burger }}
    </div>
    <div class="menu-items ul-li" v-bind:class="{ fs: isToggle }">
      <ul class="text-center">
        <li v-for="menu in burgerMenus" :key="menu.name">
          <a :href="menu.link">{{ menu.name }}</a>
        </li>
        <li v-if="!isLoggedIn">
          <a href="/login" data-target="#">SIGN-IN</a>
        </li>
        <li v-if="!isLoggedIn">
          <a href="/register" data-target="#">SIGN-UP</a>
        </li>
        <li v-if="isLoggedIn">
          <a href="/financial-statements">Manage Financial Statements</a>
        </li>
        <li v-if="isLoggedIn">
          <a href="/manageSubscription">Manage Subscription</a>
        </li>
        <li v-if="isLoggedIn">
          <a href="/payment-information">Payment Information</a>
        </li>
        <li v-if="isLoggedIn">
          <a href="/customerProfile">Profile</a>
        </li>
        <li v-if="isLoggedIn">
          <a @click="logout">Logout</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";

// import JQuery from 'jquery'
export default {
  data: function () {
    return {
      email: "",
      password: "",
      formError: "",
      isToggle: false,
      burger: "☰",
      showProducts: false,
      adsenseContent: "",
    };
  },
  /* Computed */
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.user.isLoggedIn,
      submitted: (state) => state.submitted,
      notifications: (state) => state.notifications,
      menus: (state) => state.menus,
      burgerMenus: (state) => state.burgerMenus,
      loggedInUser: (state) => state.user.loggedInUser,
      isLoading: (state) => state.isLoading,
    }),
    isLoginPage: function () {
      return this.$route.path === "/login";
    },
  },
  mounted() {
    // this.adsenseContent = document.getElementById(
    //   "divadsensedisplaynone"
    // ).innerHTML;
  },
  /* Methods */
  methods: {
    logout: async function () {
      await this.$store.dispatch("USER_LOGOUT");
      this.$router.push("/");
    },
    login: function () {
      if (this.isLoggedIn) {
        this.$router.push({
          name: "TransformationInput",
          params: { type: "FinancialStatements" },
        });
      } else {
        this.$router.push({ path: "/login" });
      }
    },

    menuToggle() {
      this.isToggle = !this.isToggle;
    },
    showdropdown() {
      this.showProducts = !this.showProducts;
    },
  },
};
</script>
<style>
.navbar-nav .dropdown-menu {
  position: absolute !important;
}
.fix-height {
  height: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/GuestHeader.vue